import {Swiper} from '$c3base/swiper-imports.js'

export function initPartnerFilter() {
    const forms = $('.partner-list-search');
    forms.each(function () {
        const form = $(this);
        const input = form.find('.partner-search');
        const container = form.parents('.partner-list');
        const items = container.find('.partner-list-item');

        /** @type {Map<HTMLDivElement, string>} */
        const itemTitles = new Map();

        items.each(function () {
            itemTitles.set(this, this.dataset.title.toLowerCase());
        });

        form.submit(function (e) {
            e.preventDefault();
            const value = input.val();

            itemTitles.forEach((title, item) => {
                $(item).toggleClass('partner-list-item-hidden', value.length > 0 && !title.includes(value.toLowerCase()));
            });
        });
    });
}

export function initPartnerSwiper() {
    $('.partners-swiper').each(function () {
        new Swiper(this, {
            slidesPerView: 5,
            slidesPerGroup: 5,
            grid: {
                rows: 3,
                fill: 'row'
            },
            spaceBetween: 20,
            breakpoints: {
                340: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                    grid: {
                        rows: 3,
                    },
                },
                600: {
                    slidesPerView: 8,
                    slidesPerGroup: 8,
                    grid: {
                        rows: 3,
                    },
                },
                990: {
                    slidesPerView: 10,
                    slidesPerGroup: 10,
                    spaceBetween: 24,
                    grid: {
                        rows: 3,
                    },
                },
                1200: {
                    spaceBetween: 40,
                    slidesPerView: 14,
                    slidesPerGroup: 14,
                    grid: {
                        rows: 3,
                    },
                },
            },
            grabCursor: true,
            pagination: {
                el: $(this).find('.swiper-pagination')[0],
                clickable: true
            },
            navigation: {
                nextEl: $(this).siblings('.swiper-button-next')[0],
                prevEl: $(this).siblings('.swiper-button-prev')[0]
            }
        });
    });
}